class ToggleContent {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.button = wrapper.querySelector('.toggle-content-btn');
    this.fullText = wrapper.querySelector('.extra-content');
    this.shortText = wrapper.querySelector('.short-content');

    if (this.button && this.fullText) {
      this.button.addEventListener('click', this.toggleContent.bind(this));
    }
  }

  toggleContent(event) {
    event.preventDefault();
    
    const isExpanded = this.button.getAttribute('data-expanded') === 'true';

    this.fullText.classList.toggle('hidden', isExpanded);
    this.button.textContent = isExpanded ? "Read More" : "Read Less";
    this.button.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
  }
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.custom-text-wrapper').forEach(wrapper => {
    new ToggleContent(wrapper);
  });
});

document.addEventListener("shopify:section:load", function () {
  document.querySelectorAll('.custom-text-wrapper').forEach(wrapper => {
    new ToggleContent(wrapper);
  });
});
